import React, { Fragment } from 'react';
import { Helpers } from '../../../core/src/helpers';
import BundleContainer from './bundle-container';

const { memoize } = Helpers;

export const buildBundles = memoize((props) => {
    const { productsList, metaData, sku }= props;
    return metaData.xsell.reduce((result, bundleItem, index) => {
        //checking if transformedBundle is in productsList, skipping if not
        let isAddOnMissing = false;
        let transformedBundle;
        const addOns = bundleItem.products.reduce((arr, sku, i)=>{
            //skipping the first element since it will be an actual bundleProduct
            let addOnPrd = (productsList || []).filter(prd => prd.sku === sku)[0];
            //checking if addOnPrd is missing
            if(!addOnPrd){
                isAddOnMissing = true;
                return arr;
            };
            //short it down to the attrs that will be actually used
            const { attributes, categories, itemId, listPrice, name, prdClass  } = addOnPrd;
            addOnPrd = Object.assign({ metadata: { quantity: bundleItem.quantity[i] } }, {

                attributes,
                categories,
                itemId,
                listPrice,
                name,
                prdClass,
                sku
            });
            arr.push(addOnPrd);
            return arr;
        },[]);
        //creating a custom metadata attr for each bundle
        const metadata = {
            icon: bundleItem.icon || '',
            optionName: bundleItem.key,
            preselected: bundleItem.preselected || false,
            valuemsg: bundleItem.valuemsg,
            disclaimer: bundleItem.disclaimer || false
        };
        if(!isAddOnMissing){
            transformedBundle = { bundleIndex: index, products: addOns, metadata }
            result.push(transformedBundle);
        }
        //if addOnMissing, then skipping the whole transformedBundle
        return result;
    },[]);
});

const BundleModule = (props) => {
    const bundles = buildBundles(props);
    return(
        <Fragment>
            <BundleContainer {...props} bundles={bundles}/>
        </Fragment>
    );
}

export default BundleModule;
